/**
 * UI-6b Task 8 — AgentUtilization config editor.
 *
 * Comma-separated agent UUIDs (empty = all agents). We avoid a /agents
 * fetch to keep the composer round-trip-free in Phase 1.
 */
import { useEffect, useState, type JSX } from 'react'
import { InputText } from 'primereact/inputtext'
import type { AgentUtilizationConfig } from './Renderer.js'

interface Props {
  config: AgentUtilizationConfig
  onChange: (next: AgentUtilizationConfig) => void
}

function parseList(raw: string): string[] {
  return raw
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
}

export function AgentUtilizationConfigEditor({ config, onChange }: Props): JSX.Element {
  const [raw, setRaw] = useState<string>(() => (config.agentIds ?? []).join(', '))

  useEffect(() => {
    const incoming = (config.agentIds ?? []).join(', ')
    setRaw((prev) => (parseList(prev).join(', ') === incoming ? prev : incoming))
  }, [config.agentIds])

  return (
    <div className="flex flex-col gap-3" data-testid="agent-utilization-config-editor">
      <label className="flex flex-col gap-1 text-sm">
        <span className="font-medium">Agent IDs (comma-separated, blank = all)</span>
        <InputText
          value={raw}
          onChange={(e): void => {
            const next = e.target.value
            setRaw(next)
            onChange({ ...config, agentIds: parseList(next) })
          }}
          placeholder="agent-uuid-1, agent-uuid-2"
          aria-label="Agent IDs"
        />
      </label>
    </div>
  )
}
